import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SidebarPopupMenu } from "../SidebarPopupMenu";
import LoadFileMenuItem from "./LoadFileMenuItem";
import FromPDBMenuItem from "./FromPDBMenuItem";
import FromSMILESMenuItem from "./FromSMILESMenuItem";
function FileUploadMenu({ handleClose, anchorEl, menuIsOpen, handleLoadFiles, handleLoadPDB, handleLoadSmiles, }) {
    return (_jsx(SidebarPopupMenu, Object.assign({ handleClose: handleClose, anchorEl: anchorEl, menuIsOpen: menuIsOpen }, { children: _jsxs("div", { children: [_jsx(LoadFileMenuItem, { callback: handleLoadFiles }), _jsx(FromPDBMenuItem, { callback: handleLoadPDB }), _jsx(FromSMILESMenuItem, { callback: handleLoadSmiles })] }) })));
}
export default FileUploadMenu;
